module.exports = __webpack_public_path__ + "static/nidhi-coding-fallback-cc413ee70136bcd4c669b7c1c3b40e5e.png";